module.exports = __webpack_public_path__ + "media/images/keensight-419094e8.png";